/**
 * Step-oriented computed properties for the guided report builder.
 */
const build_count_label = (component, count, singular, plural) => {
  const label = count === 1 ? singular : plural;
  return component.translate_label(`${count} ${label}`);
};

const build_data_step_title = (component) => {
  if (component.is_question_scope_report) {
    return component.translate_label("Questions");
  }
  return component.translate_label("Grouping");
};

const build_data_step_summary = (component) => {
  if (component.is_question_scope_report) {
    return component.question_setup_value;
  }
  return component.translate_label(component.non_question_scope_summary_description);
};

export default {
  show_builder_mode_toggle() {
    return this.is_profile_scope;
  },
  is_accordion_mode() {
    return this.builder_view_mode === "accordion";
  },
  is_advanced_mode() {
    return this.builder_view_mode === "advanced";
  },
  show_step_pills() {
    return !this.is_accordion_mode && !this.is_advanced_mode;
  },
  builder_steps() {
    return [
      {
        key: "basics",
        title: this.translate_label("Basics"),
        summary: `${this.selected_report_type_label} | ${this.selected_output_format_label}`,
      },
      {
        key: "scope",
        title: this.translate_label("Scope"),
        summary: `${this.scope_summary_value} | ${this.date_summary_value}`,
      },
      {
        key: "data_selection",
        title: build_data_step_title(this),
        summary: build_data_step_summary(this),
      },
      {
        key: "columns",
        title: this.translate_label("Columns"),
        summary: build_count_label(
          this,
          this.selected_field_ids.length,
          "column",
          "columns"
        ),
      },
      {
        key: "review",
        title: this.translate_label("Review"),
        summary: this.generated_report
          ? this.translate_label(
              this.generated_report.status?.display_name || "Completed"
            )
          : this.translate_label("Ready to generate"),
      },
    ];
  },
  current_step_index() {
    return this.builder_steps.findIndex((step) => step.key === this.current_step_key);
  },
  current_step() {
    return this.builder_steps[this.current_step_index] || this.builder_steps[0];
  },
  previous_step_key() {
    const previous_step = this.builder_steps[this.current_step_index - 1];
    return previous_step?.key || null;
  },
  next_step_key() {
    const next_step = this.builder_steps[this.current_step_index + 1];
    return next_step?.key || null;
  },
  is_review_step() {
    return this.current_step_key === "review";
  },
  review_generate_label() {
    if (this.generating_report) {
      return this.translate_label("Generating...");
    }
    if (this.is_editing_template) {
      return this.translate_label("Update template and generate");
    }
    return this.translate_label("Generate report");
  },
  footer_title() {
    if (this.is_advanced_mode) {
      return this.translate_label("Advanced mode");
    }
    return this.translate_label("Current step");
  },
  footer_value() {
    if (this.is_advanced_mode) {
      return this.translate_label("All sections are available");
    }
    return this.current_step?.title;
  },
  footer_description() {
    if (this.is_advanced_mode) {
      return this.translate_label(
        "Use this mode when you want the full builder visible at once."
      );
    }
    return this.current_step?.summary;
  },
};
